import { render, staticRenderFns } from "./Evolve.vue?vue&type=template&id=f510aaea&scoped=true&"
import script from "./Evolve.vue?vue&type=script&lang=js&"
export * from "./Evolve.vue?vue&type=script&lang=js&"
import style0 from "./Evolve.vue?vue&type=style&index=0&id=f510aaea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f510aaea",
  null
  
)

export default component.exports